<template>
    <div>
        <label>Fecha de inicio:</label><br>
        <date-picker v-model="filters.timeInit" valueType="'YYYY-MM-DD'"></date-picker>
        <br><label>Fecha de termino:</label><br>
        <date-picker v-model="filters.timeEnd" valueType="'YYYY-MM-DD'"></date-picker><br>
    
        <br><br>
    </div>
</template>

<script>
export default {
    name: "FilterReporteRutas",
    data() {
        return {
            selectTodasAgencias:false,
            selectTodasAreas:false,
            selectTodosTiposGestores:false,
            selectTodosGestores:false,
            selectTodosEstados:false,
            selectTodasCiudades:false,
            selectTodosCanales:false,
            selectTodasCadenas:false,
            selectTodosFormatos:false,
            selectTodasTiendas:false,
            optionsAgencias:[],
            optionsAgenciasReal:[],
            optionsAreas:[],
            optionsAreasReal:[],
            optionsTiposGestores:[],
            optionsGestores:[],
            optionsGestoresReal:[],
            optionsEstados:[],
            optionsEstadosReal:[],
            optionsCiudades:[],
            optionsCiudadesReal:[],
            optionsCanales:[],
            optionsCanalesReal:[],
            optionsCadena:[],
            optionsCadenaReal:[],
            optionsFormatos:[],
            optionsFormatosReal:[],
            optionsTiendas:[],
            optionsTiendasReal:[],
            filters:{
                timeInit: null,
                timeEnd: null,
                agencias:null,
                agenciasReal:null,
                areas:null,
                areasReal:null,
                estatusTienda:null,
                tiposGestores:null,
                gestores:null,
                estados:null,
                estadosReal:null,
                ciudades:null,
                ciudadesReal:null,
                canales:null,
                canalesReal:null,
                cadenas:null,
                cadenasReal:null,
                formatosReal:null,
                formatos:null,
                tiendas:null,
                tiendasReal:null,
            },
            optionsEstatus: [
                { name: 'Todos', language: 'Todos' },
                { name: 'Visitada', language: 'Visitada' },
                { name: 'Pendiente', language: 'Pendiente' },
                { name: 'En Proceso', language: 'En Proceso' },
            ],
        }
    },
    mounted() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var date = '' + yyyy + '-' + mm + '-' + dd + '';
        this.timeInit = '\'' + date.toString() + '\'';
        this.timeEnd = '\'' + date.toString() + '\'';
        
    },
    methods:{
       
    }
}
</script>

<style scoped>

</style>
